import {createContext, useContext} from "react";
import {Currency} from "types/global";

export const CurrenciesContext = createContext<Currency[] | null>(null);

export const useCurrencies = (): Currency[] => {
  const context = useContext(CurrenciesContext);
  if (!context) {
    throw new Error("useCurrencies must be used within a CurrenciesProvider");
  }
  return context;
};
